
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RotatingSquare } from "react-loader-spinner";

const AgentAccount = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [isAgentOn, setIsAgentOn] = useState(false);
    const [AgentData, setAgentData] = useState([]);
    const [AgentAccountData, setAgentAccountData] = useState({});

    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/agent-account/view/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setAgentData(data?.data);
                if (data) {
                    setIsAgentOn(data?.data?.status)
                }

            });
    }, [AgentAccountData]);


    const refSubmitDis = useRef();


    const handleSubmitData = async () => {
        const button = refSubmitDis.current;

        if (button) {
            button.disabled = true;
        }

        try {
            const res = await fetch(
                "https://api.velormall.com/api/admin/agent-account/create",
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ id }),
                }
            );

            const data = await res.json();

            if (!res.ok || !data.success) {
                toast.error(data.message || "Something went wrong");
                return;
            }

            toast.success(data.message);
            setAgentAccountData(data?.data);
        } catch (error) {
            console.error(error);
            toast.error("Server error. Please try again.");
        } finally {
            if (button) {
                button.disabled = false;
            }
        }
    };



    if (AgentData?.role === "admin") {
        return <></>;
    }

    return (

        <>

            <div className="card mt-30">
                <div className="card-header d-flex align-items-center gap-2">
                    <h5 className="card-title mb-0">
                        Agent Account
                    </h5>

                    <label className={`agent-switch ${isAgentOn ? "active" : ""}`}>
                        <input
                            type="checkbox"
                            checked={isAgentOn}
                            onChange={(e) => {
                                const checked = e.target.checked;

                                setIsAgentOn(checked);

                                // Disable button after click
                                if (refSubmitDis.current) {
                                    refSubmitDis.current.setAttribute("disabled", "disabled");
                                }

                                handleSubmitData();
                            }}
                        />

                        <span className="agent-slider">
                            <span className="switch-text">
                                {isAgentOn ? "ON" : "OFF"}
                            </span>
                        </span>
                    </label>
                </div>
                <div className="card-body">


                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="firstname" className="required">
                                    Agent Email
                                </label>

                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        type="text"
                                        readOnly
                                        value={isAgentOn ? AgentData?.email || "" : ""}
                                        id="firstname"
                                    />

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={!isAgentOn || !AgentData?.email}
                                        onClick={async () => {
                                            try {
                                                await navigator.clipboard.writeText(AgentData.email);
                                                toast.success("Email copied!");
                                            } catch {
                                                toast.error("Failed to copy Email");
                                            }
                                        }}
                                    >
                                        <i className="las la-copy"></i> Copy
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="password" className="required">
                                    Password
                                </label>

                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        type="text"
                                        readOnly
                                        value={isAgentOn ? AgentData?.password || "" : ""}
                                        id="password"
                                    />

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={!isAgentOn || !AgentData?.password}
                                        onClick={async () => {
                                            try {
                                                await navigator.clipboard.writeText(AgentData.password);
                                                toast.success("Password copied!");
                                            } catch {
                                                toast.error("Failed to copy password");
                                            }
                                        }}
                                    >
                                        <i className="las la-copy"></i> Copy
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>

    );

};

export default AgentAccount;
